import { gsap } from 'gsap';

export default class ProcessAnimationTurns {
	constructor(elm) {
		this.elm = elm;

		this.dot1 = this.elm.querySelector('[data-process-animation-turns-dot1]');
		this.dot2 = this.elm.querySelector('[data-process-animation-turns-dot2]');

		this.chapter1 = this.elm.querySelector('[data-process-animation-turns-chapter1]');
		this.chapter2 = this.elm.querySelector('[data-process-animation-turns-chapter2]');
		this.chapter3 = this.elm.querySelector('[data-process-animation-turns-chapter3]');
		this.chapter4 = this.elm.querySelector('[data-process-animation-turns-chapter4]');
		this.chapter5 = this.elm.querySelector('[data-process-animation-turns-chapter5]');
		this.chapter6 = this.elm.querySelector('[data-process-animation-turns-chapter6]');

		this.tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 0,
			onStart: () => {
				gsap.set(this.dot1, {
					xPercent: this.dotHome * -1,
					autoAlpha: 1,
				});
				gsap.set(this.dot2, {
					xPercent: this.dotHome,
					autoAlpha: 1,
				});

				gsap.set([this.chapter1, this.chapter2, this.chapter3, this.chapter4, this.chapter5, this.chapter6], {
					scaleX: 0,
				});
			},
			onComplete: () => {},
		});

		this.dotHome = 200;
		this.dotCenter = 50;

		// Chapter 1: Chapter 1 In
		this.tl.fromTo(
			this.chapter1,
			{
				scaleX: 0,
			},
			{
				scaleX: 1,
				duration: 2,
				ease: 'power2.inOut',
			},
			0
		);

		// Chapter 1: Dot 1 In
		this.tl.fromTo(
			this.dot1,
			{
				xPercent: this.dotHome * -1,
				'--dot-blur': '10px',
			},
			{
				xPercent: this.dotCenter,
				'--dot-blur': '0px',
				duration: 2,
				ease: 'power2.inOut',
			},
			0
		);

		// Chapter 2: Chapter 2 In
		this.tl.fromTo(
			this.chapter2,
			{
				scaleX: 0,
			},
			{
				scaleX: 1,
				duration: 2,
				ease: 'power4.inOut',
			},
			2
		);

		// Chapter 2: Dot 2 In
		this.tl.fromTo(
			this.dot2,
			{
				xPercent: this.dotHome,
				'--dot-blur': '10px',
			},
			{
				xPercent: this.dotCenter * -1,
				'--dot-blur': '0px',
				duration: 2,
				ease: 'power4.inOut',
			},
			2
		);

		// Chapter 2: Dot 1 Out
		this.tl.fromTo(
			this.dot1,
			{
				xPercent: this.dotCenter,
				'--dot-blur': '0px',
			},
			{
				xPercent: this.dotHome * -1,
				'--dot-blur': '10px',
				duration: 2,
				ease: 'power4.inOut',
			},
			2
		);

		// Chapter 3: Chapter 3 In
		this.tl.fromTo(
			this.chapter3,
			{
				scaleX: 0,
			},
			{
				scaleX: 1,
				duration: 2,
				ease: 'sine.inOut',
			},
			4
		);

		// Chapter 3: Dot 1 In
		this.tl.fromTo(
			this.dot1,
			{
				xPercent: this.dotHome * -1,
				'--dot-blur': '3px',
			},
			{
				xPercent: this.dotCenter,
				'--dot-blur': '0px',
				duration: 2,
				ease: 'sine.inOut',
			},
			4
		);

		// Chapter 3: Dot 2 Out
		this.tl.fromTo(
			this.dot2,
			{
				xPercent: this.dotCenter * -1,
				'--dot-blur': '0px',
			},
			{
				xPercent: this.dotHome,
				'--dot-blur': '10px',
				duration: 1,
				ease: 'power2.in',
			},
			4.8
		);

		// Chapter 4: Chapter In
		this.tl.fromTo(
			this.chapter4,
			{
				scaleX: 0,
			},
			{
				scaleX: 1,
				duration: 1.5,
				ease: 'expo.inOut',
			},
			5.8
		);

		// Chapter 4: Dot 2 In
		this.tl.fromTo(
			this.dot2,
			{
				xPercent: this.dotHome,
				'--dot-blur': '10px',
			},
			{
				xPercent: this.dotCenter * -1,
				'--dot-blur': '0px',
				duration: 1.5,
				ease: 'expo.inOut',
			},
			5.8
		);

		// Chapter 4: Dot 1 Out
		this.tl.fromTo(
			this.dot1,
			{
				xPercent: this.dotCenter,
				'--dot-blur': '0px',
			},
			{
				xPercent: this.dotHome * -1,
				'--dot-blur': '10px',
				duration: 1.5,
				ease: 'expo.inOut',
			},
			6.3
		);

		// Chapter 5: Chapter 5
		this.tl.fromTo(
			this.chapter5,
			{
				scaleX: 0,
			},
			{
				scaleX: 1,
				duration: 1,
				ease: 'power2.inOut',
			},
			8.3
		);

		// Chapter 5: Dot 1 In
		this.tl.fromTo(
			this.dot1,
			{
				xPercent: this.dotHome * -1,
				'--dot-blur': '10px',
			},
			{
				xPercent: this.dotCenter,
				'--dot-blur': '0px',
				duration: 1,
				ease: 'power2.inOut',
			},
			8.3
		);

		// Chapter 5: Dot 2 Out
		this.tl.fromTo(
			this.dot2,
			{
				xPercent: this.dotCenter * -1,
				'--dot-blur': '0px',
			},
			{
				xPercent: this.dotHome,
				'--dot-blur': '10px',
				duration: 1,
				ease: 'power2.inOut',
			},
			8.3
		);

		// Chapter 6: Chapter 5
		this.tl.fromTo(
			this.chapter6,
			{
				scaleX: 0,
			},
			{
				scaleX: 1,
				duration: 2,
				ease: 'power4.inOut',
			},
			9.8
		);

		// Chapter 6: Dot 2 In
		this.tl.fromTo(
			this.dot2,
			{
				xPercent: this.dotHome,
				'--dot-blur': '10px',
			},
			{
				xPercent: this.dotCenter * -1,
				'--dot-blur': '0px',
				duration: 2,
				ease: 'power4.inOut',
			},
			9.8
		);

		// Chapter 6: Dot 1 Out
		this.tl.fromTo(
			this.dot1,
			{
				xPercent: this.dotCenter,
				'--dot-blur': '0px',
			},
			{
				xPercent: this.dotHome * -1,
				'--dot-blur': '10px',
				duration: 2,
				ease: 'power4.inOut',
			},
			9.3
		);

		// Cleanup: Chapters
		this.tl.fromTo(
			[this.chapter1, this.chapter2, this.chapter3, this.chapter4, this.chapter5, this.chapter6],
			{
				scaleX: 1,
			},
			{
				scaleX: 0,
				duration: 1,
				ease: 'power4.inOut',
			},
			11.8
		);

		// Cleanup: Dot 2 Out
		this.tl.fromTo(
			this.dot2,
			{
				xPercent: this.dotCenter * -1,
				'--dot-blur': '0px',
			},
			{
				xPercent: this.dotHome,
				'--dot-blur': '10px',
				duration: 1,
				ease: 'power4.inOut',
			},
			11.8
		);
	}
}
